import {Dispatch} from "redux";
import {IResponse, RACARequest} from "../../Request";
import requestMiddlewares from "../../requestMiddlewares";
import {getSession} from "../../../utils/sessionStorage";
import {setMainRole, setUser} from "../../../store/slices/userMeSlice";
import {setPermissions} from "../../../store/slices/permissionsSlice";
import IUser from "../../../interfaces/IUser";

export default async function getMyProfileRequest(
  dispatch: Dispatch,
): Promise<IResponse> {
  const session = getSession()
  if (!session?.token) throw new Error('session has not defined');

  const request = new RACARequest('me', 'myProfile');

  const response = await request.makeRequest();
  requestMiddlewares(
    dispatch,
    response,
  );
  
  if (response.data) {
    const userData = response.data as IUser;
    dispatch(
      setUser(userData)
    );

    dispatch(
      setMainRole(userData.role)
    )

    if (userData?.role?.permissions) {
      dispatch(
        setPermissions(userData.role.permissions),
      );
    }
  }

  return response;
}
